import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Packages
import moment from 'moment';
import currencyFormatter from 'currency-formatter';
import shortid from 'shortid';

// Components
import DropdownOverflowMenu from './DropdownOverflowMenu';
import MenuItem from '../MenuItem';
import ExpanderTable from './ExpanderTable';

class ObjectRowAdminAccount extends Component {
  constructor(props) {
      super(props);
  }

  static propTypes = {
    rowData: PropTypes.object.isRequired,
    appName: PropTypes.string
  }

  state = {
    rowType: 'default',
    expanded: false,
  }

  componentDidMount() {
    let { rowData, isChecked } = this.props;
    this.setRowType(rowData.rowType);
  }

  setRowType(rowType) {
    this.setState(state => ({
      ...state,
      rowType: rowType
    }))
  }

  handleExpanderClick = (event) => {
    event.preventDefault();
    let { rowType, expanded } = this.state;

    if (rowType === 'expander') {
      this.setState(state => ({
        ...state,
        expanded: !expanded
      }))
    }
  }

  renderPrimaryColumn = (rowData) => {
    let { primaryColumn, rowLinkPath, fullRowIsClickable } = rowData;

    let rowDescriptor =
      primaryColumn.rowDescriptor ? (
        <div className="row-descriptor">
          {primaryColumn.rowDescriptor}
        </div>
      ) : null


    let primaryContent = (
      <div className="object-row-header-name">
        {primaryColumn.title}
      </div>
    )

    let secondaryContent =
      primaryColumn.secondaryInfo ? (
        <div className="object-row-header-secondary-info">
          {primaryColumn.secondaryInfo}
        </div>
      ) : null

    if (rowLinkPath && !fullRowIsClickable) {
      return (
        <Link
          className="object-row-header"
          to={rowLinkPath}
        >
          {rowDescriptor}
          {primaryContent}
          {secondaryContent}
        </Link>
      )
    } else {
      return (
        <div className="object-row-header">
          {rowDescriptor}
          {primaryContent}
          {secondaryContent}
        </div>
      )
    }
  }

  renderLatestPaymentDate = (payments) => {
    const latestPayment = payments.reduce(function(previousPayment, currentPayment) {
      return (previousPayment.timestamp > currentPayment.timestamp) ? previousPayment : currentPayment
    })

    let dateString = moment.unix(latestPayment.timestamp / 1000).format("MM/DD/YYYY");

    return dateString
  }

  renderOutstandingDebt = (debts) => {
    let totalDebt = debts.reduce((sum, debt) => {
      return sum + debt.balance;
    }, 0);

    return currencyFormatter.format(totalDebt, { code: 'USD' });
  }

  renderSecondaryColumns = (columns) => {
    if (columns.length > 0) {
      return (
        <div className="object-row-data">
          {columns.map((column) => {
            return (
              <div
                key={shortid.generate()}
                className="object-row-data-column"
              >
                <div
                  className={`object-row-data-column-inner${column.optionalClasses ? ' ' + column.optionalClasses : ''}`}
                >
                  {column.title}
                </div>
              </div>
            );
          })}
        </div>
      )
    }
  }

  renderRowActionButton = (rowType, rowActions) => {

    let { expanded } = this.state;

    if (rowType === 'overflowMenu' ) {
      return (
        <DropdownOverflowMenu>
          {
            rowActions.map((rowAction) => {
              return (
                <MenuItem
                  key={shortid.generate()}
                  dataBehavior={rowAction.dataBehavior}
                  dataTarget={rowAction.dataTarget}
                  dataThreshold={rowAction.dataThreshold ? rowAction.dataThreshold : ''}
                  optionalClasses={rowAction.optionalClasses}
                  handleClick={(event) => this.props.handleRowActionClick(event)}
                  verified={rowAction.verified ? rowAction.verified : ''}
                  startMails={rowAction.startMails ? rowAction.startMails : ''}
                >
                  {rowAction.title}
                </MenuItem>
              )
            })
          }
        </DropdownOverflowMenu>
      )
    } else if (rowType === 'expander') {
      return (
        <a
          className={`object-row-expander${expanded ? ' active' : ''}`}
          onClick={(event) => this.handleExpanderClick(event)}
        >
          <svg className="icon"><use xlinkHref="#arrow-right"/></svg>
        </a>
      )
    } else if (rowType === 'clickThrough') {
      return (
        <svg className="object-row-arrow"><use xlinkHref="#arrow-right"/></svg>
      )
    }
  }

  renderExpanderContent = (expanderOptions) => {
    let { expanded } = this.state;

    if (expanderOptions) {
      return (
        <ExpanderTable
          options={expanderOptions}
          isExpanded={expanded}
        />
      )
    }
  }

  getOptionalRowClasses = (rowData) => {
    let classes = '';

    if (rowData.rowType === 'expander') {
      classes += ' expander';
    }

    if (rowData.optionalRowClasses) {
      classes += ' ' + rowData.optionalRowClasses;
    }

    return classes;
  }

  render() {
    let { rowData, checkeObjList, hideCheckBox } = this.props;
    let optionalClasses = this.getOptionalRowClasses(rowData);

    let rowInner = (
      <div className="object-row-inner">
        <div className="object-row-content">
          {this.renderPrimaryColumn(rowData)}
          {this.renderSecondaryColumns(rowData.secondaryColumns)}
          {this.renderRowActionButton(rowData.rowType, rowData.rowActions)}
        </div>
        {this.renderExpanderContent(rowData.expanderOptions)}
      </div>
    );

    return rowData.fullRowIsClickable
    ? (
      <Link
        to={rowData.rowLinkPath}
        className={`object-row object-row-link${optionalClasses}`}
      >
        {rowInner}
      </Link>
    )
    : (
      //1236
      <div className="admin-form-row-with-checkbox">
        {!hideCheckBox && <div>
            <input
                name = {rowData.consumerId}
                value = {rowData.consumerId}
                key = {rowData.consumerId}
                type="checkbox"
                checked = {rowData.isSelected}
                style={{WebkitAppearance: `checkbox`, width: `20px`, marginRight: `10px`, marginTop: `-5px` }}
                onChange={(event) => this.props.action(event)}/>
        </div>}
        <div className={`object-row${optionalClasses}`}>
          {rowInner}
        </div>
        </div>
      )
  }
}

export default ObjectRowAdminAccount;
